import { Url } from '../shared/Url';
import Post from '../shared/Post';
import { cookieData } from '../funciones/ConsultaUser';
import { requerido, numero } from './Validaciones'

export const PreferenciasAdmin = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }

        Post(`${Url}consultaPreferenciasAdmin`, Content, (resp) => {
            let data = JSON.parse(resp)
            let meses = ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO", "JULIO", "AGOSTO", "SEPTTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"];
            let contenido = { value: data[0].id, label: `${meses[(data[0].corte_name) - 1]} - ${data[0].corte_year}` };
            let contenido2 = { value: data[2].id, label: `${meses[(data[2].corte_name) - 1]} - ${data[2].corte_year}` };

            let texto = { value: 0, label: 'Desactivado' }
            if (data[0].disabled_mora === 1) texto = { value: 1, label: 'Activado' }
            respuesta ([data[0], data[1], contenido, texto, contenido2, data[3]])
        });
    });
}

export const GuardarFecha = (campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];
    let mensaje = [];

    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            campos: campos
        }

        Post(`${Url}GuardarPreferenciasAdminFecha`, Content, (resp) => {
            
            mensaje = [{
                status: "info",
                mensaje: "Se han guardado correctamente los cambios"
            }];

            respuesta([states, mensaje, errores, nameErr])
        });
    });
}

export const GuardarCarrLog = (id, valor, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id, 
            valor: valor
        }
        
        Post(`${Url}GuardarCarrLog`, Content, (resp) => {
            let data = JSON.parse(resp)

            respuesta(data)
        })
    });
}

export const Guardar = (campos, respuesta) => {
    let errores = 0;
    let nameErr = [];
    let states = [];

    let mensaje = [{
        status: "error",
        mensaje: "No se pudo guardar la información. Revisa los errores encontrados para continuar"
    }];

    /* Validaciones */
    requerido(errores, campos.periodosDispSelect.value, "", "", "", "Debes seleccionar el periodo para de Inscripción Disponible", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.nextPeriodoSelect.value, "", "", "", "Debes seleccionar el Periodo Siguiente", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.cuotas, "", "", "", "Debes indicar la cantidad de cuotas de los aranceles de materias inscritas", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.maxCitasAdm, "", "", "", "Debes indicar la cantidad máxima de citas diarias para Admisión", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.maxCitasInc, "", "", "", "Debes indicar la cantidad máxima de citas diarias para Reinscripción", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.intervalo, "", "", "", "Debes indicar el mínimo de dias para la asignación de citas", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.valorUc, "", "", "", "Debes indicar el valor de la Unidad de Crédito ALUMNOS REGULARES", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.valorUcNi, "", "", "", "Debes indicar el valor de la Unidad de Crédito NUEVO INGRESO", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.valorDivisa, "", "", "", "Debes indicar el monto de la tasa de cambio de Divisas", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.vencimiento, "", "", "", "Debes indicar la cantidad de dias para el vencimiento de los aranceles", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.interesSelect.value, "", "", "", "Debes indicar los intereses por la cobranza morosa", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.inscNi, "", "", "", "Debes indicar un monto de INSCRIPCIÓN", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    requerido(errores, campos.inscRg, "", "", "", "Debes indicar un monto de REINSCRIPCIÓN", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    numero(errores, campos.cuotas, "", "", "El campo Cuotas debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    numero(errores, campos.maxCitasAdm, "", "", "El campo Cantidad máx. de citas de Admision debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    numero(errores, campos.maxCitasInc, "", "", "El campo Cantidad máx. de citas de Reinscripción debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    numero(errores, campos.intervalo, "", "", "El campo Intervalo de dias debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    numero(errores, campos.valorUc, "", "", "El campo Valor de la Unidad de Crédito debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    numero(errores, campos.valorDivisa, "", "", "El campo valor de la tasa de Divisas debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });

    numero(errores, campos.vencimiento, "", "", "El campo Dias de vencimiento debe contener solo números", (resp) => {
        errores = resp[1];
        states.push(resp[0][0])
        nameErr.push(resp[2])
    });
    
    if (errores === 0){
        cookieData((cookie) => {
            let Content = {
                uId: cookie[1],
                campos: campos
            }
    
            Post(`${Url}GuardarPreferenciasAdmin`, Content, () => {
                
                mensaje = [{
                    status: "info",
                    mensaje: "Se han guardado correctamente los cambios"
                }];

                respuesta([states, mensaje, errores, nameErr])
            });
        });
    }else{
        respuesta([states, mensaje, errores, nameErr])
    }
}

export const ConsultPeriodos = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }

        Post(`${Url}ConsultPeriodosAdmin`, Content, (resp) => {
            let data = JSON.parse(resp)
            let meses = ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO", "JULIO", "AGOSTO", "SEPTTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"];
            
            let contenido= [];
            for (let i in data[0]) {
                contenido.push(
                    { value: data[0][i].id, label: `${meses[(data[0][i].corte_name) - 1]} - ${data[0][i].corte_year}` }
                )
            }

            respuesta ([data[0], contenido])
        });
    });
}

export const SaveFeriado = (diaIn, diaOut, motivo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            diaIn: diaIn,
            diaOut: diaOut,
            motivo: motivo.toUpperCase()
        }

        Post(`${Url}AddFeriado`, Content, (resp) => {
            respuesta(resp)
        });
    });
}

export const diasDisabled = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }

        Post(`${Url}ConsultFeriado`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });
}

export const DelFechaFer = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id
        }

        Post(`${Url}DelFeriado`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });
}

export const AddDiasIsc = (diaIn, diaOut, periodo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            diaIn: diaIn,
            diaOut: diaOut,
            periodo: periodo
        }

        Post(`${Url}AddDiasIsc`, Content, (resp) => {
            respuesta(resp)
        });
    });
}

export const ConsultDiasInsc = (periodo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            periodo: periodo
        }

        Post(`${Url}ConsultDiasInsc`, Content, (resp) => {
            let data = JSON.parse(resp)

            let meses = ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO", "JULIO", "AGOSTO", "SEPTTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"];

            let contenido= [];
            for (let i in data[0]) {
                contenido.push({
                    id: data[0][i].id,
                    dia: data[0][i].dia,
                    corte: `${meses[(data[0][i].corte_name) - 1]} - ${data[0][i].corte_year}`
                })
            }

            respuesta(contenido)
        });
    });
}

export const DelDiasIsc = (id, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            id: id
        }

        Post(`${Url}DelDiasIsc`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });
}

export const CkhEstudiantes = (selectNi, tipo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            selectNi: selectNi,
            tipo: tipo
        }

        Post(`${Url}CkhEstudiantes`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data[0])
        });
    });
}

export const AnalisisInd = (est, valor1, valor2, aplCobroIns, aplCobroReIns, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            est: est,
            valor1: valor1,
            valor2: valor2,
            aplCobroIns: aplCobroIns,
            aplCobroReIns: aplCobroReIns
        }

        Post(`${Url}AnalisisInd`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const AnalisisIndRem = (est, monto, descripcion, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            est: est, 
            monto: monto,
            descripcion: descripcion
        }

        Post(`${Url}AnalisisIndRem`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const FinAnalisis = (valor, valor2, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            valor: valor,
            valor2: valor2
        }

        Post(`${Url}FinAnalisis`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}

export const FinAnalisisRem = (valor, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            monto: valor
        }

        Post(`${Url}FinAnalisisRem`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta(data)
        });
    });
}



// WEBPACK FOOTER //
// ./src/funciones/PreferenciasAdminFunction.jsx